module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyAgMAAABjUWAiAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAEM+7bwmuAAAAhklEQVR4AWKAgAAGJMC4BJnH9hOZJ/3PAYmX/38Ckrb9/58AqqQDDADCEAij9z91+/fh2QDRa8L82Az42MxCbBZisxADY2AMjIExMAbGwBgYA5eBWBALYkEsiAXvdDfvlZtw0+9n4DIwBsbAGBgDY2AMjIGPgVgQC2JBLBgDY2AMxE4jT1s/dXErhAG6bpUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map/White-Unknown.png
// module id = 582
// module chunks = 1